import {
  DATE_TIME_FILTER_FROM_FIELD_NAME,
  DATE_TIME_FILTER_TO_FIELD_NAME,
  SELECT_FILTER_ID_FIELD_NAME,
} from '@common/constants';
import { IFilter } from './searchFilter.models';

export const getFilterValue = (fieldName: string, filter: IFilter) => {
  return filter[fieldName];
};
export const getDateTimeFilterFieldNameFrom = (fieldName: string) => {
  return `${fieldName}.${DATE_TIME_FILTER_FROM_FIELD_NAME}`;
};
export const getDateTimeFilterFieldNameTo = (fieldName: string) => {
  return `${fieldName}.${DATE_TIME_FILTER_TO_FIELD_NAME}`;
};

export const getFilterFieldNameIsFromDate = (fieldName: string) => {
  return fieldName.endsWith(`.${DATE_TIME_FILTER_FROM_FIELD_NAME}`);
};

export const getSelectFilterFieldNameId = (fieldName: string) => {
  return `${fieldName}.${SELECT_FILTER_ID_FIELD_NAME}`;
};

export const getActualFilterFieldName = (fieldName: string) => {
  if (fieldName.endsWith(`.${DATE_TIME_FILTER_FROM_FIELD_NAME}`)) {
    return fieldName.substring(0, fieldName.lastIndexOf(`.${DATE_TIME_FILTER_FROM_FIELD_NAME}`));
  }
  if (fieldName.endsWith(`.${DATE_TIME_FILTER_TO_FIELD_NAME}`)) {
    return fieldName.substring(0, fieldName.lastIndexOf(`.${DATE_TIME_FILTER_TO_FIELD_NAME}`));
  }
  if (fieldName.endsWith(`.${SELECT_FILTER_ID_FIELD_NAME}`)) {
    return fieldName.substring(0, fieldName.lastIndexOf(`.${SELECT_FILTER_ID_FIELD_NAME}`));
  }
  return fieldName;
};
